export const EmptyBlueBoxImage = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => {
  return (
    <svg
      width="256"
      height="120"
      viewBox="0 0 256 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
    >
      <path
        d="M208.97 13H50.2371V106.45H208.97V13Z"
        fill="#B0C8F2"
        stroke="#1D2B47"
      />
      <path
        d="M28.1839 41.6034H95.4331L117.486 13H50.2372L28.1839 41.6034Z"
        fill="white"
        stroke="#1D2B47"
      />
      <path
        d="M208.97 13H117.486V106.45H208.97V13Z"
        fill="#B0C8F2"
        stroke="#1D2B47"
      />
      <path
        d="M136.918 41.6034H228.184L208.752 13H117.486L136.918 41.6034Z"
        fill="white"
        stroke="#1D2B47"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M92.8118 84.8328H58.5319V96.8409H92.8118V84.8328Z"
        stroke="#1D2B47"
      />
    </svg>
  )
}
